var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 91,
    viewBox: "0 0 102 91",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4679 90.2488H90.5329C98.6179 90.2488 103.658 81.4814 99.6154 74.4988L60.0829 6.19635C56.0404 -0.786152 45.9604 -0.786152 41.9179 6.19635L2.38539 74.4988C-1.65711 81.4814 3.38289 90.2488 11.4679 90.2488ZM51.0004 53.4989C48.1129 53.4989 45.7504 51.1364 45.7504 48.2489V37.7488C45.7504 34.8613 48.1129 32.4988 51.0004 32.4988C53.8879 32.4988 56.2504 34.8613 56.2504 37.7488V48.2489C56.2504 51.1364 53.8879 53.4989 51.0004 53.4989ZM56.2504 74.4988H45.7504V63.9989H56.2504V74.4988Z",
    fill: "#C4C4C4"
  })));
};

export default __webpack_public_path__ + "static/media/iconWarning.de3fda47.svg";
export { SvgIconWarning as ReactComponent };